export default "__VITE_ASSET__72ae4efa__"